import React from 'react'
import './Intro.scss'
import { Link } from 'gatsby'
import loadable from '@loadable/component'

const Animation = loadable(() => import('../Animation/Animation'), {
	fallback: <div className="loading-animation">Laster animasjon...</div>
})

const Intro = ({title, leadParagraph, animation}) => {
	return(
		<div className="CaseContent-Intro">
			<Animation animationname={animation} />
			<div className="CaseContent-Intro-Wrapper grid">
				<div className="back">
					<Link to={`/kundehistorier`}>Tilbake</Link>
				</div>
				<div className="content">
					<h1>{title}</h1>
					<p className="lead" dangerouslySetInnerHTML={{__html: leadParagraph}} />
				</div>
			</div>
		</div>
	)
}

export default Intro